import { useMemo } from "react";
import toast from "react-hot-toast";
import { truncateAddress } from "../../utils/string";
import { TextLink, TextSecondary } from "../DesignSystem/DesignSystemText";

interface Props {
  items: any[];
  count?: number;
  limit?: number;
  offset?: number;
  onShowMore?: any;
}

const AddressList = ({ items, count, limit, offset, onShowMore }: Props) => {
  const addressListItems = useMemo(() => {
    const sliceLimit = (offset ?? 0) + (limit ?? 0);
    const itemsToShow = items?.slice(0, sliceLimit);

    return itemsToShow?.map((item, i) => {
      const displayName = truncateAddress(
        item.username || item.accountDisplayId || item.accountUniqId,
      );

      return [
        // Only link to profile if username exists
        item.username ? (
          <li key={item.username}>
            <TextLink href={"/profile/" + item.username}>
              {displayName}
            </TextLink>
          </li>
        ) : (
          <li key={item.username}>
            <TextSecondary key={i}>{displayName}</TextSecondary>
          </li>
        ),
      ];
    });
  }, [items]);

  return (
    <>
      <ul>{addressListItems}</ul>

      {addressListItems.length < (count ?? 0) && (count ?? 0) > (limit ?? 0) && (
        <button
          className="mt-3"
          type="button"
          onClick={async () => {
            try {
              await onShowMore();
            } catch (error: any) {
              toast.error(error.message);
            }
          }}
        >
          <TextSecondary>
            ↳ see {(count || 0) - addressListItems.length} more
          </TextSecondary>
        </button>
      )}
    </>
  );
};

export default AddressList;
